import React from "react"
import ReactSelect from "react-select"
import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import * as styles from "./FormImageTags.module.scss"

const TagImage = (props) => {
  if (!props.photos[props.id]) {
    return null
  }

  const onChange = (selected, type) => props.handleChangePhotos(selected, type, props.id)
  const { customData } = props.photos[props.id]

  const categoryOption =
    customData.category &&
    props.categoryOptions.find((option) => option.value === customData.category.value)
  const serviceOptions = categoryOption ? categoryOption.tags : []

  return (
    <div className={styles.TagImage}>
      <img src={props.url} alt="" />
      <div className={styles.input}>
        <div className={styles.reactSelect}>
          <label>Type of party:</label>
          <ReactSelect
            styles={props.reactSelectStyles}
            classNamePrefix="react-select"
            className="react-select-container"
            name="category"
            isMulti={false}
            onChange={onChange}
            options={props.categoryOptions}
            value={
              customData.category &&
              props.categoryOptions.filter(
                (option) => option.value === customData.category.value
              )
            }
          />
        </div>
        <div className={styles.reactSelect}>
          <label>Service:</label>
          <ReactSelect
            styles={props.reactSelectStyles}
            classNamePrefix="react-select"
            className="react-select-container"
            name="service"
            isDisabled={!customData.category}
            isMulti={false}
            onChange={onChange}
            options={serviceOptions}
            value={
              customData.service &&
              serviceOptions.filter((option) => option.value === customData.service.value)
            }
          />
        </div>
        <div className={styles.reactSelect}>
          <label>Style:</label>
          <ReactSelect
            styles={props.reactSelectStyles}
            classNamePrefix="react-select"
            className="react-select-container"
            name="style"
            isMulti={false}
            onChange={onChange}
            options={props.styleOptions}
            value={
              customData.style &&
              props.styleOptions.filter((option) => option.value === customData.style.value)
            }
          />
        </div>
        <div className={styles.reactSelect}>
          <label>Setting:</label>
          <ReactSelect
            styles={props.reactSelectStyles}
            classNamePrefix="react-select"
            className="react-select-container"
            name="setting"
            isMulti={false}
            onChange={onChange}
            options={props.settingOptions}
            value={
              customData.setting &&
              props.settingOptions.filter((option) => option.value === customData.setting.value)
            }
          />
        </div>
        <div className={styles.full}>
          <label>Other suppliers in photo?:</label>
          <ReactSelect
            styles={props.reactSelectStyles}
            classNamePrefix="react-select"
            className="react-select-container"
            name="othersuppliers"
            isMulti
            onChange={onChange}
            options={props.supplierOptions}
            value={
              customData.othersuppliers && customData.othersuppliers.length
                ? props.supplierOptions.filter((option) =>
                    customData.othersuppliers.find((el) => el.value === option.value)
                  )
                : null
            }
          />
        </div>
      </div>
    </div>
  )
}

const FormImageTags = (props) => (
  <section className={styles.FormImageTags}>
    <h3>Image Tagging</h3>
    <p>Tag each of your photos to help Users find you through our new Moodboard feature!</p>
    <div className={styles.results}>
      {props.photos && Object.values(props.photos) && Object.values(props.photos).length ? (
        Object.values(props.photos).map((photo) => (
          <TagImage
            key={photo.id}
            photos={props.photos}
            {...photo}
            reactSelectStyles={props.reactSelectStyles}
            handleChangePhotos={props.handleChangePhotos}
            categoryOptions={props.categoryOptions}
            styleOptions={props.styleOptions}
            settingOptions={props.settingOptions}
            supplierOptions={props.supplierOptions}
          />
        ))
      ) : (
        <FetchSpinner />
      )}
    </div>
  </section>
)

export default FormImageTags
